import {
	FrontendCompanySampleMatrix,
	FrontendCompanyTestCategory,
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GreenButton } from "../../../../common-components/button";
import { ModalWithButtons } from "../../../../common-components/modals/modal";

import SpecificationFilesAndFoldersContents from "../../clientOrganizations/subComponents/specificationFilesAndFoldersContents";

interface Props {
	user: FrontendUserInfo;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	orderTestCategory: FrontendCompanyTestCategory;
	selectedMatrix: FrontendCompanySampleMatrix;
	specDirectories: Array<FrontendSampleSpecificationDirectory>;
	currentFolderSpecifications: Array<FrontendSampleSpecification>;

	selectedSpecificationId: string | undefined;
	setSelectedSpecificationId: React.Dispatch<
		React.SetStateAction<string | undefined>
	>;
}

export default function SelectSpecificationFileModal(props: Props) {
	const { t: translation } = useTranslation();
	const {
		user,
		open,
		setOpen,
		orderTestCategory,
		currentFolderSpecifications,
		selectedMatrix,
		specDirectories,
	} = props;

	// This state will now be updated when a user clicks a file in the folder view
	const [selectedSpecificationId, setSelectedSpecificationId] = useState<
		string | undefined
	>(props.selectedSpecificationId);

	// We need to manage the folder state within the modal now
	const [currentFolder, setCurrentFolder] = useState<
		FrontendSampleSpecificationDirectory | undefined
	>();

	function handleSave() {
		props.setSelectedSpecificationId(selectedSpecificationId);
		setOpen(false);
	}

	const fileSelector: React.ReactNode = (
		<div style={{ marginTop: "20px", minHeight: "400px" }}>
			<SpecificationFilesAndFoldersContents
				user={props.user} // Pass from parent
				orgDetailsSelectedCategory={orderTestCategory} // Pass from parent
				orgSpecifications={currentFolderSpecifications}
				setOrgSpecifications={() => {}} // Disable editing in selection mode
				specDirectories={specDirectories}
				selectedMatrix={selectedMatrix}
				currentFolder={currentFolder}
				setCurrentFolder={setCurrentFolder}
				setSpecDirectories={() => {}}
				isInsideModal={true} // This hides the Upload/Delete buttons
				// Custom prop we will add to handle selection
				setSelectedSpecificationId={setSelectedSpecificationId}
				selectedSpecificationId={selectedSpecificationId}
			/>
		</div>
	);

	return (
		<ModalWithButtons
			modalWidth={800} // Increased width for the folder view
			headerText={translation("Selectfile")}
			open={open}
			setOpen={setOpen}
			buttons={[
				<GreenButton
					key="save"
					size="flex"
					disabled={!selectedSpecificationId}
					onClick={handleSave}
					id={"select-spec-button"}
				>
					{translation("Save")}
				</GreenButton>,
			]}
		>
			{fileSelector}
		</ModalWithButtons>
	);
}
